import type { CSSProperties } from 'react'
import { DashboardAuthProvider, useDashboardAuth } from './auth/DashboardAuthProvider'
import { NoPortalAccess, SignIn } from './auth/SignIn'
import { canUsePortal } from './auth/permissions'
import { DashboardShell } from './DashboardShell'

/**
 * The app's four states, in the order they are decided:
 *   booting     — the session probe is in flight. Render nothing structural; a flash of the
 *                 sign-in form for an already-signed-in user is a lie the eye believes.
 *   signed-out  — the sign-in form.
 *   signed-in, no provider permission — the refusal (see SignIn.tsx: a different failure).
 *   signed-in, admitted — the portal.
 */

const booting: CSSProperties = {
  minHeight: '100%',
  display: 'grid',
  placeItems: 'center',
  color: 'var(--muted-foreground)',
  fontSize: 'var(--fs-sm)',
}

function Routes() {
  const { status, user, signOut } = useDashboardAuth()

  if (status === 'booting') return <div style={booting}>Loading…</div>
  if (status === 'signed-out' || !user) return <SignIn />
  if (!canUsePortal(user)) return <NoPortalAccess email={user.EmailAddress} onSignOut={signOut} />
  return <DashboardShell user={user} onSignOut={signOut} />
}

export function App() {
  return (
    <DashboardAuthProvider>
      <Routes />
    </DashboardAuthProvider>
  )
}
